export enum PageLayout {
  Authorized = 'authorized',
  UnAuthorized = 'unauthorized',
  UnAuthenticated = 'unauthenticated',
  Error = 'error',
}
